<template>
    <div>
        <div class="card">
            <div class="card-header py-0 px-0">
                <div class="team-actions d-flex justify-content-between px-0">
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'teams' }"
                            @click.prevent="openTab('teams')"
                        >
                            <i class="fa mr-2 fa-building"></i>
                            <span>Teams</span>
                        </a>
                    </div>
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'add-teams' }"
                            @click.prevent="openTab('add-teams')"
                        >
                            <i class="fa mr-2 fa-plus"></i>
                            <span>Add New</span>
                        </a>
                    </div>
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'groups' }"
                            @click.prevent="openTab('groups')"
                        >
                            <i class="fas mr-2 fa-users"></i>
                            <span>Groups</span>
                        </a>
                    </div>
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'users' }"
                            @click.prevent="openTab('users')"
                        >
                            <i class="fa mr-2 fa-user"></i>
                            <span>Users</span>
                        </a>
                    </div>
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'integrations' }"
                            @click.prevent="openTab('integrations')"
                        >
                            <i class="fa mr-2 fa-plug"></i>
                            <span>Integrations</span>
                        </a>
                    </div>
                    <div class="col px-0">
                        <a
                            href="#"
                            class="tab border-bottom text-center d-block w-100 py-3 light-text"
                            :class="{ active: tab == 'stats' }"
                            @click.prevent="openTab('stats')"
                        >
                            <i class="fa mr-2 fa-signal"></i>
                            <span>Stats</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="card-body py-0">
                <component :is="activeComponent"></component>
            </div>
        </div>
    </div>
</template>

<script>
import AdminTeams from "./AdminTeams";
import AdminAddTeams from "./AdminAddTeams";
import AdminGroups from "./AdminGroups";
import AdminStats from "./AdminStats";
import AdminIntegrations from "./AdminIntegrations";
import AdminUsers from "./AdminUsers";

export default {
    components: {
        AdminTeams,
        AdminAddTeams,
        AdminGroups,
        AdminStats,
        AdminIntegrations,
        AdminUsers
    },
    computed: {
        activeComponent() {
            return "admin-" + this.tab;
        }
    },
    data() {
        return {
            tab: "teams"
        };
    },
    methods: {
        openTab(tab) {
            this.tab = tab;
        }
    }
};
</script>

<style scoped>
.tab {
    border-bottom-width: 2px;
    font-weight: bold;
    font-size: 14px;
}
.tab.active,
.tab:hover {
    color: #fff;
    border-bottom: solid 2px #00aef1 !important;
    background: #00aef1;
}
</style>
